import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { VolumesSection } from './components/VolumesSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-charcoal-950 font-sans text-body" data-id="element-0" data-mp="23ti67z10skhk">
      <Hero data-id="element-1" data-mp="3ijfv1zlojwem" />

      <main data-id="element-2" data-mp="3ihv1odb3qjic">
        <TestimonialsSection data-id="element-3" data-mp="3ii4r9zs8ioni" />
        <PainSection data-id="element-4" data-mp="3ml1234bj9ggw" />
        <SystemRevealSection data-id="element-5" data-mp="3mk8710lxsfel" />
        <VolumesSection data-id="element-6" data-mp="3mjga9mglsbmq" />
        <IncludesSection data-id="element-7" data-mp="3rcj6618urx63" />
        <BonusesSection data-id="element-8" data-mp="3rbzq6q2rjiup" />
        <OfferSection data-id="element-9" data-mp="3rcswjpxt86cb" />
        <TestimonialsSection variant="compact" id="proof-2" data-id="element-10" data-mp="3reltuemj9e7n" />
        <GuaranteeSection data-id="element-11" data-mp="4n5i12o8na1" />
        <FaqSection data-id="element-12" data-mp="82kz509bybz" />
        <CostSection data-id="element-13" data-mp="2zl3brl12165b" />
        <FinalOfferSection data-id="element-14" data-mp="2zllijblcf2rh" />
      </main>

      <Footer data-id="element-15" data-mp="2zmwj72jhrued" />
      <StickyCta data-id="element-16" data-mp="2zn678kkz7rhf" />
    </div>;
}